module.exports = __webpack_public_path__ + "webstatic/img/zfzcwz.9eadef6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/new/zfzcwz.png
// module id = nF4/
// module chunks = 3